import React from 'react';
import { Circle, X } from 'lucide-react';
import { t } from '../i18n';
import './CardJudgmentFeedback.css';

export const JUDGMENT_FEEDBACK_MS = 500;
export const COMPACT_JUDGMENT_FEEDBACK_MS = 260;

function CardJudgmentFeedback({ result = null, compact = false, points = 0 }) {
  if (result !== 'correct' && result !== 'retry') return null;

  const label = t(`practiceUi.encounter.${result === 'correct' ? 'remembered' : 'practiceAgain'}`);
  const pointLabel = points > 0 ? `+${points} pt` : '';
  return (
    <div className={`card-judgment-feedback is-${result}${compact ? ' is-compact' : ''}`} role="status"
      aria-label={pointLabel ? `${label}, ${pointLabel}` : label}
      aria-live="polite" aria-atomic="true">
      <div className="card-judgment-mark">
        {result === 'correct'
          ? <Circle size={compact ? 36 : 160} strokeWidth={3} aria-hidden="true" />
          : <X size={compact ? 36 : 160} strokeWidth={3} aria-hidden="true" />}
        {!compact && <span>{label}</span>}
        {pointLabel && <span className="card-judgment-points">{pointLabel}</span>}
      </div>
    </div>
  );
}

export default CardJudgmentFeedback;
